export default __webpack_public_path__ + "static/media/galleryimg2.13a3fa39.jpg";